import React from 'react'

// デフォルトレイアウト要素(Header, Sidebar)を非表示にしたい場合に、pagesのLayoutプロパティに代入する
export const LayoutWithNothing = React.Fragment
